import { useEffect, useState } from 'react';
import { GetAppData } from 'pages/ApplicationMaintenance/_api';
import styles from '../../../../ApplicationMaintenance.module.scss';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import Modal from '@mui/material/Modal';
import Base from '../../../../../Base/Base';
import AppDataDisplay from './components/AppDataDisplay';
import { AppData } from 'Classes/ResponseModels/ApplicationManagement/AppManagementModel';

const AppDataManagement = ({
	component,
	app,
	currentUser,
	reload,
	readOnly,
	requirementNumber,
}) => {
	const [modalOpen, setModalOpen] = useState(false);
	const [sComponent, setComponent] = useState(component);
	const [sLoading, setLoading] = useState(false);

	useEffect(() => {
		const load = async () => {
			setLoading(true);
			let componentCopy = { ...sComponent };
			const arrAppData = await GetAppData(sComponent?.id);
			componentCopy.appData = arrAppData.map(data => new AppData(data));
			setComponent(componentCopy);
			setLoading(false);
		};
		if (modalOpen) {
			load();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modalOpen]);

	return (
		<div>
			<div>
				<div className={styles.controlsContainer}>
					<Button
						id='app_ComponentForm_modal_open'
						onClick={() => setModalOpen(true)}
						startIcon={<MaterialIcon icon='edit' />}
					>
						{readOnly ? 'View Data' : 'Edit Data'}
					</Button>
				</div>
				<Modal
					open={modalOpen}
					onClose={() => {
						setModalOpen(false);
					}}
				>
					<div className={styles.Modal}>
						<Base title='Edit Component Data' loading={sLoading}>
							<AppDataDisplay
								component={sComponent}
								app={app}
								currentUser={currentUser}
								reload={reload}
								readOnly={readOnly}
								requirementNumber={requirementNumber}
							/>
						</Base>
					</div>
				</Modal>
			</div>
		</div>
	);
};

export default AppDataManagement;
